/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selection_Last_LabelInputs */

const en_audio_description_export_selection_last_label = /** @type {(inputs: Audio_Description_Export_Selection_Last_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Event`)
};

const fr_audio_description_export_selection_last_label = /** @type {(inputs: Audio_Description_Export_Selection_Last_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernier événement`)
};

const de_audio_description_export_selection_last_label = /** @type {(inputs: Audio_Description_Export_Selection_Last_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letztes Ereignis`)
};

const it_audio_description_export_selection_last_label = /** @type {(inputs: Audio_Description_Export_Selection_Last_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo evento`)
};

const ru_audio_description_export_selection_last_label = /** @type {(inputs: Audio_Description_Export_Selection_Last_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее событие`)
};

const es_audio_description_export_selection_last_label = /** @type {(inputs: Audio_Description_Export_Selection_Last_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último evento`)
};

const zh_cn2_audio_description_export_selection_last_label = /** @type {(inputs: Audio_Description_Export_Selection_Last_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上次活动`)
};

const ja_audio_description_export_selection_last_label = /** @type {(inputs: Audio_Description_Export_Selection_Last_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後のイベント`)
};

const hi_audio_description_export_selection_last_label = /** @type {(inputs: Audio_Description_Export_Selection_Last_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम कार्यक्रम`)
};

const pt_pt2_audio_description_export_selection_last_label = /** @type {(inputs: Audio_Description_Export_Selection_Last_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último evento`)
};

/**
* | output |
* | --- |
* | "Last Event" |
*
* @param {Audio_Description_Export_Selection_Last_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selection_last_label = /** @type {((inputs?: Audio_Description_Export_Selection_Last_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selection_Last_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_selection_last_label(inputs)
	if (locale === "de") return de_audio_description_export_selection_last_label(inputs)
	if (locale === "it") return it_audio_description_export_selection_last_label(inputs)
	if (locale === "ru") return ru_audio_description_export_selection_last_label(inputs)
	if (locale === "es") return es_audio_description_export_selection_last_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_selection_last_label(inputs)
	if (locale === "ja") return ja_audio_description_export_selection_last_label(inputs)
	if (locale === "hi") return hi_audio_description_export_selection_last_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_selection_last_label(inputs)
	return en_audio_description_export_selection_last_label(inputs)
});